import { ErrorCodesEnum } from '../enums';
import type { AuthContextProps, ResultData } from '../types';

export const initialAuthContext: AuthContextProps = {
    isAuthenticated: false,
    logout: () => {},
    isLoggingOut: false,
    isAuthenticating: false,
    initValidatePhone: async () => {},
    loginWithPhoneAndOtp(): Promise<ResultData> {
        return Promise.resolve({
            message: 'Login with phone and OTP successfully',
            errorCode: ErrorCodesEnum.SUCCESS,
        });
    },
    registerNewAccountByOtp(): Promise<ResultData> {
        return Promise.resolve({
            message: 'Register new account by OTP successfully',
            errorCode: ErrorCodesEnum.SUCCESS,
        });
    },
    requestValidatePhone(): Promise<{
        message: string;
        errorCode: string;
    }> {
        return Promise.resolve({
            message: '',
            errorCode: ErrorCodesEnum.SUCCESS,
        });
    },
    confirmRequestedValidationPhone(): Promise<ResultData> {
        return Promise.resolve({
            message: 'Confirm requested validation phone successfully',
            errorCode: ErrorCodesEnum.SUCCESS,
        });
    },
};
